import { render, staticRenderFns } from "./edit-select-team-number.vue?vue&type=template&id=96eb9e4a&scoped=true&"
import script from "./edit-select-team-number.vue?vue&type=script&lang=js&"
export * from "./edit-select-team-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96eb9e4a",
  null
  
)

export default component.exports